var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.loading)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-text',[_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1)],1)],1):(_vm.emptyInsights)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" No hay datos por mostrar ")])],1)],1)],1):_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"space-between"}},[(_vm.insights.totalProcessedAudios)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Audios Procesados "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"green"}},[_vm._v("cloud_upload")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"green","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.totalProcessedAudios.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.totalProcessedSeconds)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Segundos procesados "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"amber lighten-2"}},[_vm._v("watch_later")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"amber lighten-2","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.totalProcessedSeconds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.averageTimePerCall)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Tiempo Promedio por llamada "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("call")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"blue","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(((_vm.insights.averageTimePerCall.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")) + " seg")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.percentageSilents)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Porcentaje de Silencios "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"deep-orange darken-1"}},[_vm._v("volume_off")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"deep-orange darken-1","rotate":-90,"size":100,"width":15,"value":parseFloat(_vm.insights.percentageSilents) * 100}},[_vm._v(_vm._s((parseFloat(_vm.insights.percentageSilents) * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."))+"%")])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.averageConversations)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Conversaciones promedio "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"total"}},[_vm._v("record_voice_over")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"total","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.averageConversations.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.promiseCalls)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Llamadas tipo promesa "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"amber lighten-2"}},[_vm._v("call")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"amber lighten-2","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.promiseCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.negotiationCalls)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Llamadas tipo negociación "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"green"}},[_vm._v("record_voice_over")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"green","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.negotiationCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.reluctantCalls)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Llamadas tipo Renuente "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"total"}},[_vm._v("mdi-emoticon-confused")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"total","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.reluctantCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])],1)],1)],1)],1)],1):_vm._e(),(_vm.insights.averagePickupTime)?_c('v-col',[_c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(" Tiempo promedio para contestar "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"total"}},[_vm._v("ring_volume")])],1),_c('v-divider'),_c('v-card-text',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"color":"total","rotate":-90,"size":100,"width":15,"value":100}},[_vm._v(_vm._s(_vm.insights.averagePickupTime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."))+" seg")])],1)],1)],1)],1)],1):_vm._e()],1)],1),(_vm.insights.averageCallTime)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v("Promedio de tiempo de llamada general")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                              chart: {
                                type: 'boxplot'
                              },
                              title: {
                                text: ''
                              },
                              legend: {
                                enabled: false
                              },
                              xAxis: {
                                categories: ['Todas las llamadas'],
                                title: {
                                  text: ''
                                }
                              },
                              yAxis: {
                                title: {
                                  text: 'Tiempo'
                                },
                                plotLines: []
                              },
                              series: [{
                                name: 'Tiempo',
                                data: [
                                  [40, 178, 259, 487, 903]
                                ],
                                tooltip: {
                                  headerFormat: '<em>{point.key}</em><br/>'
                                }
                              }],
                              credits: false
                            }}})],1)],1)],1):_vm._e(),(_vm.insights.pickupTime)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Tiempo para contestar ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":_vm.responseTimeData}})],1)],1)],1):_vm._e(),(_vm.insights.successStartConversation)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Inician correctamente la conversación ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                            chart: {
                              plotBackgroundColor: null,
                              plotBorderWidth: null,
                              plotShadow: false,
                              type: 'pie'
                            },
                            title: {
                              text: ''
                            },
                            subtitle: {
                              text: ""
                            },
                            tooltip: {
                              pointFormat: '{series.name}: <b>{point.y}</b>'
                            },
                            plotOptions: {
                              pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                  enabled: true,
                                  format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                  style: {
                                    color: (_vm.Highcharts.theme && _vm.Highcharts.theme.contrastTextColor) || 'black'
                                  }
                                }
                              }
                            },
                            series: [{
                              name: '',
                              colorByPoint: true,
                              data: [{
                                name: 'No',
                                y: 28,
                                sliced: true,
                                selected: true,
                                color: '#d13f2b'
                              }, {
                                name: 'Si',
                                y: 72,
                                color: 'rgb(65, 168, 128)'
                              }]
                            }],
                            credits: false
                          }}})],1)],1)],1):_vm._e(),(_vm.insights.requestForWaitTime)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Piden Tiempo de espera ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                            chart: {
                              plotBackgroundColor: null,
                              plotBorderWidth: null,
                              plotShadow: false,
                              type: 'pie'
                            },
                            title: {
                              text: ''
                            },
                            subtitle: {
                              text: ""
                            },
                            tooltip: {
                              pointFormat: '{series.name}: <b>{point.y}</b>'
                            },
                            plotOptions: {
                              pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                  enabled: true,
                                  format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                  style: {
                                    color: (_vm.Highcharts.theme && _vm.Highcharts.theme.contrastTextColor) || 'black'
                                  }
                                }
                              }
                            },
                            series: [{
                              name: '',
                              colorByPoint: true,
                              data: [{
                                name: 'Si',
                                y: 83,
                                sliced: true,
                                selected: true,
                                color: '#d13f2b'
                              }, {
                                name: 'No',
                                y: 17,
                                color: 'rgb(65, 168, 128)'
                              }]
                            }],
                            credits: false
                          }}})],1)],1)],1):_vm._e(),(_vm.insights.waitTimes)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Tiempos de espera ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":_vm.waitTimes}})],1)],1)],1):_vm._e(),(_vm.insights.justifiedWaitTime)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Justificación de tiempo de espera ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                            chart: {
                              plotBackgroundColor: null,
                              plotBorderWidth: null,
                              plotShadow: false,
                              type: 'pie'
                            },
                            title: {
                              text: ''
                            },
                            subtitle: {
                              text: ""
                            },
                            tooltip: {
                              pointFormat: '{series.name}: <b>{point.y}</b>'
                            },
                            plotOptions: {
                              pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                  enabled: true,
                                  format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                  style: {
                                    color: (_vm.Highcharts.theme && _vm.Highcharts.theme.contrastTextColor) || 'black'
                                  }
                                }
                              }
                            },
                            series: [{
                              name: '',
                              colorByPoint: true,
                              data: [{
                                name: 'No',
                                y: 75,
                                sliced: true,
                                selected: true,
                                color: '#d13f2b'
                              }, {
                                name: 'Si',
                                y: 25,
                                color: 'rgb(65, 168, 128)'
                              }]
                            }],
                            credits: false
                          }}})],1)],1)],1):_vm._e(),(_vm.insights.giveServiceTime)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Dan el número de servicio ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":_vm.giveServiceNumberData}})],1)],1)],1):_vm._e(),(_vm.insights.inappropiateWords)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Palabras inadecuadas ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                            chart: {
                              plotBackgroundColor: null,
                              plotBorderWidth: null,
                              plotShadow: false,
                              type: 'pie'
                            },
                            title: {
                              text: ''
                            },
                            subtitle: {
                              text: ""
                            },
                            tooltip: {
                              pointFormat: '{series.name}: <b>{point.y}</b>'
                            },
                            plotOptions: {
                              pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                  enabled: true,
                                  format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                  style: {
                                    color: (_vm.Highcharts.theme && _vm.Highcharts.theme.contrastTextColor) || 'black'
                                  }
                                }
                              }
                            },
                            series: [{
                              name: '',
                              colorByPoint: true,
                              data: [{
                                name: 'Si',
                                y: 37,
                                sliced: true,
                                selected: true,
                                color: '#d13f2b'
                              }, {
                                name: 'No',
                                y: 63,
                                color: 'rgb(65, 168, 128)'
                              }]
                            }],
                            credits: false
                          }}})],1)],1)],1):_vm._e(),(_vm.insights.allowedCloseCall)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Autorización de cierre ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":_vm.closeAuthorizationData}})],1)],1)],1):_vm._e(),(_vm.insights.serviceSurvey)?_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center font-weight-bold"},[_vm._v(" Encuesta de Servicio ")]),_c('v-divider',{staticClass:"mx-4"}),_c('v-card-text',[_c('Chart',{attrs:{"options":{
                            chart: {
                              plotBackgroundColor: null,
                              plotBorderWidth: null,
                              plotShadow: false,
                              type: 'pie'
                            },
                            title: {
                              text: ''
                            },
                            subtitle: {
                              text: ""
                            },
                            tooltip: {
                              pointFormat: '{series.name}: <b>{point.y}</b>'
                            },
                            plotOptions: {
                              pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                  enabled: true,
                                  format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                  style: {
                                    color: (_vm.Highcharts.theme && _vm.Highcharts.theme.contrastTextColor) || 'black'
                                  }
                                }
                              }
                            },
                            series: [{
                              name: '',
                              colorByPoint: true,
                              data: [{
                                name: 'No',
                                y: 2,
                                sliced: true,
                                selected: true,
                                color: '#d13f2b'
                              }, {
                                name: 'Si',
                                y: 98,
                                color: 'rgb(65, 168, 128)'
                              }]
                            }],
                            credits: false
                          }}})],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }